import { render, staticRenderFns } from "./store-cate-list.vue?vue&type=template&id=0520f0ec"
import script from "./store-cate-list.vue?vue&type=script&lang=js"
export * from "./store-cate-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports